export default __webpack_public_path__ + "static/media/ny-yogi.51a7c5e3.jpg";